import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";

const Chapter8 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);


    return (
        <>

             {/* Chapter 8 */}
                <section id="section8" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">
                        {language.chapter8Title}
                    </h2>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter8Paragraph1}
                    </p>

                    <p className="drivers-handbook-paragraph">
                         {language.chapter8Paragraph2}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter8Paragraph3}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter8Paragraph4}
                    </p>

                    <p className="drivers-handbook-paragraph">
                         {language.chapter8Paragraph5}
                    </p>


                    <h3 className="drivers-handbook-subheading">{language.chapter8Subheading1}</h3>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter8Paragraph6}
                    </p>
                </section>
        </>
    )

}

export default Chapter8;
